import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

import { useI18n } from "../../I18nProvider";

export default function Territories(props) {
  const appText = useI18n();
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.contractID) {
      setIsLoading(true);
      _loadTerritories();
    }
  }, [props.contractID]);

  async function _loadTerritories() {
    await NuxeoClient.instance()
      .fetchTerritories(props.contractID)
      .then((response) => {
        setFetchedData(response);
        setIsLoading(false);
      });
  }

  const handleSelectAllClick = () => {
    let values = [];
    let ids = [];
    fetchedData.map((data) => {
      values.push(data.label);
      ids.push(data.id);
    });

    props.handleChange("territories", values);
    props.handleChange("territoriesID", ids);
  };

  const handleClearAllClick = () => {
    props.handleChange("territories", []);
    props.handleChange("territoriesID", []);
  };

  const handleChange = (territories) => {
    if (territories === null) {
      props.handleChange("territories", []);
      props.handleChange("territoriesID", []);
    } else if (territories.length > props.value.length) {
      let values = [...props.value];
      values.push(territories[territories.length - 1].label);
      props.handleChange("territories", values);

      let ids = [...props.id];
      ids.push(territories[territories.length - 1].id);
      props.handleChange("territoriesID", ids);
    } else {
      const territoriesLabels = territories.map(
        (territory) => (territory = territory.label)
      );
      const deletedTerritory = props.value.filter(
        (value) => !territoriesLabels.includes(value)
      );

      let deletedIndex;
      let values = [...props.value];
      props.value.forEach((value, index) => {
        if (value === deletedTerritory[0]) {
          deletedIndex = index;
          values.splice(index, 1);
        }
      });
      props.handleChange("territories", values);

      let ids = [...props.id];
      ids.splice(deletedIndex, 1);
      props.handleChange("territoriesID", ids);
    }
  };

  return (
    // <Tooltip arrow title="Select which territories are involved">
    <Tooltip arrow title={appText.T116}>
      <Grid item={true} xs={12}>
        <div className="territories">
          <InputLabel className="field-label field-dropdown" required>
            {/* Territories */}
            {appText.T51}
          </InputLabel>
          <Autocomplete
            type={"multi"}
            handleChange={handleChange}
            data={fetchedData}
            dataType={"territories"}
            mapVariable={"label"}
            setFilterData={() => null}
            value={props.value}
            isLoading={isLoading}
          />
          <Grid
            spacing={1}
            container={true}
            direction="column"
            alignItems="flex-start"
          >
            <Grid item={true}>
              <ButtonGroup
                size="small"
                aria-label="Medium outlined button group"
              >
                <Button
                  onClick={() => handleSelectAllClick()}
                  disabled={isLoading}
                >
                  {/* Select All */}
                  {appText.T52}
                </Button>
                <Button
                  onClick={() => handleClearAllClick()}
                  disabled={isLoading}
                >
                  {/* Clear All */}
                  {appText.T53}
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Tooltip>
  );
}
